import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Table from '@/sections/ComparisonTable';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { Link } from '@/components/links';
function ComparisonTable(t0) {
  const $ = _c(109);
  const {
    onCtaClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["cssProgram", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bgCircle absolute top-1/2 left-0 translate-x-1/4 -translate-y-1/2 rotate-90" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("comparisonTable.title");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <SectionHeadline className="mb-4" anchorKey="comparisonTable.title">{t3}</SectionHeadline>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("comparisonTable.text");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Text variant="p3" className="text-center">{t5}</Text>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="mx-auto max-w-192 lg:mb-16">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("comparisonTable.badge");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("comparisonTable.table.head.basic");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("comparisonTable.table.head.pro");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = {
      left: t9,
      right: t10
    };
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("comparisonTable.table.sections.1.title");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Link to={LINKS().gcssHomepage} analyticsParam="cssProgramTry" testId="cssProgramTry" />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  let t15;
  if ($[25] !== t) {
    t14 = {
      title: <Trans t={t} i18nKey="comparisonTable.table.sections.1.rows.1.text">{t13}</Trans>,
      left: true,
      right: true
    };
    t15 = t("comparisonTable.table.sections.1.rows.2.text");
    $[25] = t;
    $[26] = t14;
    $[27] = t15;
  } else {
    t14 = $[26];
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15) {
    t16 = {
      title: t15,
      left: true,
      right: true
    };
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t("comparisonTable.table.sections.1.rows.3.text");
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = {
      title: t17,
      left: false,
      right: true
    };
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Link analyticsParam="cssProgramPromotion" testId="cssProgramPromotion" to="/files/cs/Skippay_Moznosti_propagace_pro-eshopy.pdf" target="_blank" />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  let t21;
  if ($[35] !== t) {
    t20 = <Trans i18nKey="comparisonTable.table.sections.1.rows.4.text" t={t}>{t19}</Trans>;
    t21 = t("comparisonTable.table.sections.1.rows.4.tooltip");
    $[35] = t;
    $[36] = t20;
    $[37] = t21;
  } else {
    t20 = $[36];
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = {
      title: t20,
      tooltip: t21,
      left: false,
      right: true
    };
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t14 || $[42] !== t16 || $[43] !== t18 || $[44] !== t22) {
    t23 = [t14, t16, t18, t22];
    $[41] = t14;
    $[42] = t16;
    $[43] = t18;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t12 || $[47] !== t23) {
    t24 = {
      title: t12,
      items: t23
    };
    $[46] = t12;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t) {
    t25 = t("comparisonTable.table.sections.2.title");
    $[49] = t;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t) {
    t26 = t("comparisonTable.table.sections.2.tooltip");
    $[51] = t;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t("comparisonTable.table.sections.2.rows.1.text");
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t27) {
    t28 = {
      title: t27,
      left: false,
      right: true
    };
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t) {
    t29 = t("comparisonTable.table.sections.2.rows.2.text");
    $[57] = t;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t29) {
    t30 = {
      title: t29,
      left: false,
      right: true
    };
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t) {
    t31 = t("comparisonTable.table.sections.2.rows.3.text");
    $[61] = t;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t31) {
    t32 = {
      title: t31,
      left: false,
      right: true
    };
    $[63] = t31;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t) {
    t33 = t("comparisonTable.table.sections.2.rows.4.text");
    $[65] = t;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== t33) {
    t34 = {
      title: t33,
      left: false,
      right: true
    };
    $[67] = t33;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t28 || $[70] !== t30 || $[71] !== t32 || $[72] !== t34) {
    t35 = [t28, t30, t32, t34];
    $[69] = t28;
    $[70] = t30;
    $[71] = t32;
    $[72] = t34;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== t25 || $[75] !== t26 || $[76] !== t35) {
    t36 = {
      title: t25,
      tooltip: t26,
      items: t35
    };
    $[74] = t25;
    $[75] = t26;
    $[76] = t35;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] !== t24 || $[79] !== t36) {
    t37 = [t24, t36];
    $[78] = t24;
    $[79] = t36;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t) {
    t38 = t("comparisonTable.table.footer.title");
    $[81] = t;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== t) {
    t39 = t("comparisonTable.table.footer.columns.1");
    $[83] = t;
    $[84] = t39;
  } else {
    t39 = $[84];
  }
  let t40;
  if ($[85] !== t) {
    t40 = t("comparisonTable.table.footer.columns.2");
    $[85] = t;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  let t41;
  if ($[87] !== t38 || $[88] !== t39 || $[89] !== t40) {
    t41 = {
      title: t38,
      left: t39,
      right: t40
    };
    $[87] = t38;
    $[88] = t39;
    $[89] = t40;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t11 || $[92] !== t37 || $[93] !== t41 || $[94] !== t8) {
    t42 = <Table badge={t8} isSecondColumnActive={true} primaryColumn={2} titles={t11} categories={t37} footer={t41} />;
    $[91] = t11;
    $[92] = t37;
    $[93] = t41;
    $[94] = t8;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  let t43;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Link analyticsParam="googleCssVop" testId="googleCssVop" to="/files/cs/Skippay_Vseobecne_obchodni_podminky_Google_CSS.pdf" target="_blank" />;
    $[96] = t43;
  } else {
    t43 = $[96];
  }
  let t44;
  if ($[97] !== t) {
    t44 = <Text variant="p4" className="mx-auto my-12 max-w-[28rem] text-center lg:my-16"><Trans t={t} i18nKey="comparisonTable.info">{t43}</Trans></Text>;
    $[97] = t;
    $[98] = t44;
  } else {
    t44 = $[98];
  }
  let t45;
  if ($[99] !== t) {
    t45 = t("comparisonTable.button");
    $[99] = t;
    $[100] = t45;
  } else {
    t45 = $[100];
  }
  let t46;
  if ($[101] !== onCtaClick || $[102] !== t45) {
    t46 = <Button variant="primary" align="center" size="lg" onClick={onCtaClick} testId="cssProgramComparisonTableTrial" analyticsParam="cssProgramComparisonTableTrial">{t45}</Button>;
    $[101] = onCtaClick;
    $[102] = t45;
    $[103] = t46;
  } else {
    t46 = $[103];
  }
  let t47;
  if ($[104] !== t42 || $[105] !== t44 || $[106] !== t46 || $[107] !== t7) {
    t47 = <><div className="relative overflow-hidden px-5 pt-14 lg:pt-20">{t2}<div className="relative z-10">{t7}{t42}{t44}{t46}</div></div></>;
    $[104] = t42;
    $[105] = t44;
    $[106] = t46;
    $[107] = t7;
    $[108] = t47;
  } else {
    t47 = $[108];
  }
  return t47;
}
export default ComparisonTable;